import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { verifyGuard } from './core/guards/verify.guard';
import { Login } from './auth/login/login';
import { ForgetPassword } from './auth/forget-password/forget-password';
import { Otp } from './auth/otp/otp';
import { ResetPassword } from './auth/reset-password/reset-password';
import { Verify } from './auth/verify/verify';

export const routes: Routes = [
    {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then(c => c.Dashboard),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'dashboard-reports',
        loadComponent: () => import('./pages/dashboard-reports/dashboard-reports').then(c => c.DashboardReports),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'deep-reports',
        loadComponent: () => import('./pages/deep-report/deep-report').then(c => c.DeepReport),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'deep-reports/soft-deleted',
        loadComponent: () => import('./pages/deep-report/deep-report').then(c => c.DeepReport),
        canActivate: [authGuard, verifyGuard],
        data: { showSoftDeleted: true },
    },
    {
        path: 'deep-reports/new',
        loadComponent: () => import('./pages/deep-report/deep-report-create/deep-report-create').then(c => c.DeepReportCreate),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'deep-reports/edit/:id',
        loadComponent: () => import('./pages/deep-report/deep-report-edit/deep-report-edit').then(c => c.DeepReportEdit),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'deep-reports/view/:id',
        loadComponent: () => import('./pages/deep-report/deep-report-view/deep-report-view').then(c => c.DeepReportView),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'juror-reports',
        loadComponent: () => import('./pages/juror-report/juror-report').then(c => c.JurorReport),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'juror-reports/soft-deleted',
        loadComponent: () => import('./pages/juror-report/juror-report').then(c => c.JurorReport),
        canActivate: [authGuard, verifyGuard],
        data: { showSoftDeleted: true },
    },
    {
        path: 'juror-reports/new',
        loadComponent: () => import('./pages/juror-report/juror-report-create/juror-report-create').then(c => c.JurorReportCreate),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'juror-reports/edit/:id',
        loadComponent: () => import('./pages/juror-report/juror-report-edit/juror-report-edit').then(c => c.JurorReportEdit),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'juror-reports/view/:id',
        loadComponent: () => import('./pages/juror-report/juror-report-view/juror-report-view').then(c => c.JurorReportView),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'users',
        loadComponent: () => import('./pages/users/users').then(c => c.Users),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'users/soft-deleted',
        loadComponent: () => import('./pages/users/users').then(c => c.Users),
        canActivate: [authGuard, verifyGuard],
        data: { profileView: 'soft-deleted' },
    },
    {
        path: 'users/active',
        loadComponent: () => import('./pages/users/users').then(c => c.Users),
        canActivate: [authGuard, verifyGuard],
        data: { profileView: 'active' },
    },
    {
        path: 'users/admins',
        loadComponent: () => import('./pages/users/users').then(c => c.Users),
        canActivate: [authGuard, verifyGuard],
        data: { profileView: 'admins' },
    },
    {
        path: 'users/new',
        loadComponent: () => import('./pages/users/user-create/user-create').then(c => c.UserCreate),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'users/edit/:id',
        loadComponent: () => import('./pages/users/user-edit/user-edit').then(c => c.UserEdit),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'users/view/:id',
        loadComponent: () => import('./pages/users/user-view/user-view').then(c => c.UserView),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'user-activities',
        loadComponent: () => import('./pages/user-activities/user-activities').then(c => c.UserActivities),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'user-activities/view/:id',
        loadComponent: () => import('./pages/user-activities/user-activity-view/user-activity-view').then(c => c.UserActivityView),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile').then(c => c.Profile),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'invoices',
        loadComponent: () => import('./pages/invoices/invoices').then(c => c.Invoices),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'coupons',
        loadComponent: () => import('./pages/coupons/coupons').then(c => c.Coupons),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'coupons/new',
        loadComponent: () => import('./pages/coupons/coupon-create/coupon-create').then(c => c.CouponCreate),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'coupons/edit/:id',
        loadComponent: () => import('./pages/coupons/coupon-edit/coupon-edit').then(c => c.CouponEdit),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'coupons/view/:id',
        loadComponent: () => import('./pages/coupons/coupon-view/coupon-view').then(c => c.CouponView),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'invoices/view/:id',
        loadComponent: () => import('./pages/invoices/invoice-view/invoice-view').then(c => c.InvoiceView),
        canActivate: [authGuard, verifyGuard],
    },
    {
        path: 'login',
        component: Login,
    },
    {
        path: 'forget-password',
        component: ForgetPassword,
    },
    {
        path: 'otp',
        component: Otp,
        canActivate: [authGuard],
    },
    {
        path: 'verify',
        component: Verify,
        canActivate: [authGuard],
    },
    {
        path: 'reset-password',
        component: ResetPassword,
    },
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    },
];
